import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const ViewProduct = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState("");
  const URL = process.env.REACT_APP_URL;

  useEffect(() => {
    axios
      .get(`${URL}products/${id}`)
      .then((response) => {
        setProduct(response.data);
        setError("");
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setError("Product not found.");
        } else {
          setError("Error fetching product details.");
        }
      });
  }, [id, URL]);

  if (error) {
    return <div className="text-red-500 text-center mt-4">{error}</div>;
  }

  if (!product) {
    return <div className="text-center mt-4 text-gray-600">Loading...</div>;
  }

  return (
    <div className="flex justify-center items-center min-screen  p-10">
      <div className="bg-white shadow-lg rounded-xl w-full max-w-4xl p-6 border border-gray-200 flex flex-col md:flex-row">
        <div className="w-full md:w-1/2 flex flex-col items-center">
          <img
            src={`${URL}upload/${product.image1 || "default.jpg"}`}
            alt={product.name}
            className="w-64 h-64 object-cover rounded-lg border border-gray-300 shadow-sm"
          />

          <div className="flex space-x-2 mt-3">
            {product.image2 && product.image2.trim() !== "" && (
              <img
                src={`${URL}upload/${product.image2}`}
                alt={product.name}
                className="w-16 h-16 object-cover rounded-lg border border-gray-200 shadow-sm"
              />
            )}
            {product.image3 && product.image3.trim() !== "" && (
              <img
                src={`${URL}upload/${product.image3}`}
                alt={product.name}
                className="w-16 h-16 object-cover rounded-lg border border-gray-200 shadow-sm"
              />
            )}
          </div>
          
          {/* Video Display */}
          {product.video && (
            <div className="mt-4 w-full">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Product Video</h3>
              <video controls className="w-full h-64 object-cover rounded-lg border border-gray-300 shadow-sm">
                <source src={`${URL}upload/${product.video}`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          )}
        </div>

        <div className="w-full md:w-1/2 flex flex-col justify-center px-6 space-y-4">
          <div className="flex flex-col">
            <span className="text-gray-500 text-sm">Product Name:</span>
            <span className="text-lg font-semibold text-gray-900">
              {product.name}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-gray-500 text-sm">Description:</span>
            <p className="text-gray-700 text-base leading-relaxed">
              {product.description}
            </p>
          </div>

          <div className=" rounded-lg">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Product Details
            </h3>
            <ul className="text-sm text-gray-700 space-y-2">
              <li>
                <strong>Category:</strong> {product.category == "Bengal" ? "Bangel" : product.category || "N/A"}
              </li>
              <li>
                <strong>Gross Weight:</strong> {product.grossWeight || ""} gm
              </li>
              {product.goldKt ? (
                  <li>
                    <strong>Gold KT:</strong> <span>{product.goldKt} KT</span>
                  </li>
                ) : null}
                {product.goldColor ? (
                  <li>
                    <strong>Gold Color:</strong>{" "}
                    <span>{product.goldColor}</span>
                  </li>
                ) : null}
              <li>
                <strong>Diamond Weight:</strong> {product.diamondWeight || ""}{" "}
                CT
              </li>
              <li>
                <strong>Diamond Clarity:</strong>{" "}
                {product.diamondColorAndClarity || ""}
              </li>
              <li>
                <strong>Dimensions:</strong>{" "}
                {product.height ? (
                  <span> Height : {product.height} mm || </span>
                ) : null}
                {product.width ? (
                  <span> Width : {product.width} mm </span>
                ) : null}
              </li>
              <li>
                <strong>Chain Length:</strong> {product.length || ""} mm
              </li>
              <li>
                <strong>Product ID:</strong> {product.productId}
              </li>
            </ul>
          </div>

          <div className="flex space-x-4">
            <Link to="/products">
              <button className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">
                Back to List
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProduct;
